import { render, staticRenderFns } from "./index-default.vue?vue&type=template&id=0e6d84fa"
import script from "./index-default.vue?vue&type=script&lang=js"
export * from "./index-default.vue?vue&type=script&lang=js"
import style0 from "./index-default.vue?vue&type=style&index=0&id=0e6d84fa&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e6d84fa')) {
      api.createRecord('0e6d84fa', component.options)
    } else {
      api.reload('0e6d84fa', component.options)
    }
    module.hot.accept("./index-default.vue?vue&type=template&id=0e6d84fa", function () {
      api.rerender('0e6d84fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/index-default.vue"
export default component.exports